import { memo } from 'react';
import { Box, Icon, Text } from '@betty/moonlight';
import { formatNumber } from '../../../utils/number';
import { CommunityJackpotRewardCardProps } from './CommunityJackpotRewardCard.types';
import CommunityJackpotCard from '../../CommunityJackpotCard/CommunityJackpotCard';

function CommunityJackpotRewardCard({
  amount,
  ...rest
}: CommunityJackpotRewardCardProps) {
  const icon = (
    <Icon
      name="bettyCoin"
      gradient="accentBackground"
      width="space-500"
      height="space-500"
    />
  );

  return (
    <CommunityJackpotCard {...rest}>
      <Text variant="h1" gradient="darkSurfaceAccent" textAlign="center">
        {formatNumber(amount, ',')}
      </Text>
      <Box flexDirection="row" gap="space-400" centerContent>
        {icon}
        <Text
          variant="callout"
          gradient="darkSurfaceAccent"
          locKey="bettyCoins"
          locNS="communityJackpot"
        />
        {icon}
      </Box>
    </CommunityJackpotCard>
  );
}

export default memo(CommunityJackpotRewardCard);
